// extracted by mini-css-extract-plugin
export default {"wrapper":"Stats_wrapper__PX6Rd","cardContent":"Stats_cardContent__qO9Ig"};